import slick from 'slick-carousel'
  
let $billboard = $('.billboard');

const billboard = {
	init: function(){
		if ($billboard.length) {
			billboard.setup();
		}
	},

	setup: function(){

		if($billboard.children().length > 1){
			
			$billboard.each(function(){
				
				$billboard = $(this);

				$billboard.slick({
					slidesToShow: 1,
					arrow: true,
					dots: true,
					// adaptiveHeight: true,
					autoplay: true,
					autoplaySpeed: 2000
				});

			});
		}
	}
}


export default billboard;;